import { css } from '@emotion/react';

export const attributeColumns = css`
  .themed {
    --columns-justify-content: space-between;
  }
`;
